/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_FontsInputs */

const en_custom_fonts = /** @type {(inputs: Custom_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Fonts`)
};

const fr_custom_fonts = /** @type {(inputs: Custom_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polices personnalisées`)
};

const de_custom_fonts = /** @type {(inputs: Custom_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte Schriftarten`)
};

const it_custom_fonts = /** @type {(inputs: Custom_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteri personalizzati`)
};

const ru_custom_fonts = /** @type {(inputs: Custom_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательские шрифты`)
};

const es_custom_fonts = /** @type {(inputs: Custom_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuentes personalizadas`)
};

const zh_cn2_custom_fonts = /** @type {(inputs: Custom_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义字体`)
};

const ja_custom_fonts = /** @type {(inputs: Custom_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタムフォント`)
};

const hi_custom_fonts = /** @type {(inputs: Custom_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कस्टम फोंट`)
};

const pt_pt2_custom_fonts = /** @type {(inputs: Custom_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fontes personalizadas`)
};

/**
* | output |
* | --- |
* | "Custom Fonts" |
*
* @param {Custom_FontsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_fonts = /** @type {((inputs?: Custom_FontsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_FontsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_custom_fonts(inputs)
	if (locale === "de") return de_custom_fonts(inputs)
	if (locale === "it") return it_custom_fonts(inputs)
	if (locale === "ru") return ru_custom_fonts(inputs)
	if (locale === "es") return es_custom_fonts(inputs)
	if (locale === "zh-CN") return zh_cn2_custom_fonts(inputs)
	if (locale === "ja") return ja_custom_fonts(inputs)
	if (locale === "hi") return hi_custom_fonts(inputs)
	if (locale === "pt-PT") return pt_pt2_custom_fonts(inputs)
	return en_custom_fonts(inputs)
});